import {
  ConnectWalletModalOptions,
  PrivyClientConfig,
} from '@privy-io/react-auth';
import { WagmiConfigParams } from '@vertex-protocol/react-client';
import { clientEnv } from 'common/environment/clientEnv';

const PRIVY_EXTERNAL_WALLET_LIST = [
  'detected_ethereum_wallets',
  'metamask',
  'coinbase_wallet',
  'wallet_connect',
] as const satisfies NonNullable<
  NonNullable<PrivyClientConfig['appearance']>['walletList']
>;

export const PRIVY_EMBEDDED_LOGIN_OPTIONS = {
  loginMethods: ['wallet', 'email', 'passkey'],
  walletChainType: 'ethereum-only',
  walletList: PRIVY_EXTERNAL_WALLET_LIST,
} as const satisfies Pick<
  PrivyClientConfig,
  'loginMethods'
> &
  Pick<
    NonNullable<PrivyClientConfig['appearance']>,
    'walletChainType' | 'walletList'
  >;

export const PRIVY_CONNECT_WALLET_OPTIONS = {
  walletChainType: 'ethereum-only',
  walletList: PRIVY_EXTERNAL_WALLET_LIST,
} as const satisfies ConnectWalletModalOptions;

export function getPrivyProviderConfig({
  supportedChains,
}: Pick<WagmiConfigParams, 'supportedChains'>): PrivyClientConfig {
  const walletConnectCloudProjectId =
    clientEnv.integrations.walletConnectProjectId || undefined;

  return {
    supportedChains,
    defaultChain: supportedChains[0],
    appearance: {
      theme: 'light',
      walletChainType: PRIVY_EMBEDDED_LOGIN_OPTIONS.walletChainType,
      walletList: PRIVY_EMBEDDED_LOGIN_OPTIONS.walletList,
      showWalletLoginFirst: true,
    },
    loginMethods: [...PRIVY_EMBEDDED_LOGIN_OPTIONS.loginMethods],
    walletConnectCloudProjectId,
    embeddedWallets: {
      ethereum: {
        createOnLogin: 'users-without-wallets',
      },
    },
    externalWallets: {
      walletConnect: {
        enabled: true,
      },
    },
  };
}
